import React from 'react';

const ErrorsSummary = ({
  errorTypes,
  dailyAggregatedData
}) => {
  // Получаем общее количество ошибок
  const getTotalErrors = () => {
    return Object.values(dailyAggregatedData).reduce((sum, counts) => sum + counts.total, 0);
  };

  // Получаем максимальное количество ошибок в день
  const getMaxDailyErrors = () => {
    const maxErrors = Math.max(...Object.values(dailyAggregatedData).map(counts => counts.total));
    const maxDate = Object.entries(dailyAggregatedData)
      .find(([_, counts]) => counts.total === maxErrors)?.[0] || '';
    
    if (maxDate) {
      const [year, month, day] = maxDate.split('-');
      return {
        count: maxErrors,
        date: `${day}.${month}.${year}`
      };
    }
    
    return { count: 0, date: 'N/A' };
  };

  // Получаем наиболее распространенный тип ошибки
  const getMostCommonErrorType = () => {
    const errorCounts = errorTypes.map(type => ({
      type,
      count: Object.values(dailyAggregatedData).reduce((sum, counts) => sum + (counts[type] || 0), 0)
    }));
    
    return errorCounts.sort((a, b) => b.count - a.count)[0] || { type: 'N/A', count: 0 };
  };

  const maxDailyErrors = getMaxDailyErrors();
  const mostCommonError = getMostCommonErrorType();

  return (
    <div className="w-full bg-white shadow-md rounded-lg p-4 mb-5">
      <h3 className="text-lg font-medium text-gray-700 border-b pb-2 mb-4">Error Statistics</h3>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        <div className="bg-gray-50 p-4 rounded-md">
          <p className="text-sm text-gray-500 mb-1">Total Errors</p>
          <p className="text-2xl font-semibold text-gray-800">{getTotalErrors()}</p>
        </div>
        <div className="bg-gray-50 p-4 rounded-md">
          <p className="text-sm text-gray-500 mb-1">Max Daily Errors</p>
          <p className="text-2xl font-semibold text-gray-800">{maxDailyErrors.count}</p>
          <p className="text-xs text-gray-500 mt-1">on {maxDailyErrors.date}</p>
        </div>
        <div className="bg-gray-50 p-4 rounded-md">
          <p className="text-sm text-gray-500 mb-1">Most Common Error</p>
          <p className="text-xl font-semibold text-gray-800 truncate" title={mostCommonError.type}>
            {mostCommonError.type.length > 25 ? `${mostCommonError.type.substring(0, 25)}...` : mostCommonError.type}
          </p>
          <p className="text-xs text-gray-500 mt-1">{mostCommonError.count} occurrences</p>
        </div>
      </div>
    </div>
  );
};

export default ErrorsSummary;